import React from 'react';
import { motion } from 'framer-motion';
export function WhyPrice() {
  return <section className="py-16 px-4" data-id="element-150">
      <div className="max-w-3xl mx-auto" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-brand-darker border-l-4 border-brand-orange p-8 md:p-12 rounded-r-xl shadow-2xl" data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-bold text-white uppercase mb-6" data-id="element-153">
            ¿Por qué solo $6.36?
          </h2>
          <div className="space-y-4 text-lg md:text-xl text-brand-text leading-relaxed font-medium" data-id="element-154">
            <p data-id="element-155">
              Sabemos que operamos en un mercado lleno de promesas vacías y
              suplementos caros. Por eso, hemos decidido{' '}
              <strong className="text-white" data-id="element-156">
                eliminar todas las barreras
              </strong>
              .
            </p>
            <p data-id="element-157">
              A $6.36 (menos de lo que cuesta un café premium),{' '}
              <strong className="text-white" data-id="element-158">
                no estamos buscando ganar dinero. Estamos buscando casos de
                éxito.
              </strong>{' '}
              Queremos que pruebes el sistema, veas cómo tu energía se dispara y
              nos envíes tu testimonio.
            </p>
            <p className="text-brand-orange font-bold" data-id="element-159">
              Es nuestra inversión para el lanzamiento global de 2026.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}